import type { ButtonHTMLAttributes, FC, MouseEvent } from 'react';

import { LucideX } from 'lucide-react';

import { cn } from '@shared/utils';

export type DismissButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const DismissButton: FC<DismissButtonProps> = ({ onClick, className, ...rest }) => (
  <button
    type="button"
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick?.(e as unknown as MouseEvent<HTMLButtonElement>);
      }
    }}
    className={cn(
      'ml-1 rounded-full transition-colors cursor-pointer flex items-center justify-center text-white hover:text-red-400 bg-transparent border-0 p-0 focus:outline-none size-4',
      className,
    )}
    {...rest}
  >
    <span className="rounded-full hover:bg-muted-foreground/20 transition-colors cursor-pointer flex items-center justify-center shrink-0">
      <LucideX className="size-3" />
    </span>
  </button>
);
